const prevNextArticleStyle = {
  prevNextArticleContainer: {
    marginTop: 18,
  },
  link: {
    textDecoration: "none",
  },
  prevContainer: {
    marginBottom: 18,
    height: 120,
    borderRadius: 3,
    overflow: "hidden",
    backgroundColor: "white",
    transition: "all .5s ease",
    boxShadow: "0px 0px 9px 0px rgba(0,0,0,0.6)",
    "&:hover": {
      boxShadow: "0 9px 9px 0px rgba(0, 0, 0, 0.6)",
      transform: "scale(1.01, 1.01)",
    },
  },
  nextContainer: {
    marginBottom: 18,
    height: 120,
    borderRadius: 3,
    overflow: "hidden",
    backgroundColor: "white",
    transition: "all .5s ease",
    boxShadow: "0px 0px 9px 0px rgba(0,0,0,0.6)",
    "&:hover": {
      boxShadow: "0 9px 9px 0px rgba(0, 0, 0, 0.6)",
      transform: "scale(1.01, 1.01)",
    },
  },
  titleArea: {
    fontSize: 12,
    padding: 3,
    color: "black",
  },
  padding: {
    paddingLeft: 3,
    paddingRight: 3,
  },
  preNextImg: {
    objectFit: "cover",
    height: "100%",
  },
};
export default prevNextArticleStyle;
